<template>
  <div>
    <div class="grid grid-cols-6 md:grid-rows-layout gap-4">
      <SparkButton v-for="d in dims" :key="d" :dimension="d" />
      <div class="col-span-6 md:col-span-4 text-center">
        <map-component />
      </div>

      <div class="col-span-6 md:col-span-4 text-center block md:hidden">
        <div class="w-full md:w-auto p-4 bg-brand-bright text-black md:h-32 text-center">
          <div class="text-4xl">{{ printNumber(currentDimension.value) }}</div>
          <div v-html="currentDimension.sub" />
        </div>
      </div>
      <div class="col-span-6 md:col-span-2 mb-8" v-html="currentDimension.desc"></div>

      <article class="col-span-6 md:col-span-3 mb-8">
        <header class="border-l-4 border-black pl-2 leading-tight">
          <h2 class="text-l md:text-xl">{{ charts.countries.title }}</h2>
          <p class="text-sm md:text-base">{{ charts.countries.subTitle }}</p>
        </header>
        <line-chart
          id="linechart"
          :series="countrySeries"
          :config="{
            flipTooltipDate: currentDimension.id === 'fire' ? 175 : 2550,
            dateFormatString: currentDimension.id === 'fire' ? '%e %b %Y' : '%Y'
          }"
        />
      </article>

      <article class="col-span-6 md:col-span-3 mb-8">
        <header class="border-l-4 border-black pl-2 leading-tight">
          <h2 class="text-l md:text-xl">{{ charts.region.title }}</h2>
          <p class="text-sm md:text-base">{{ charts.region.subTitle }}</p>
        </header>
        <line-chart
          id="total-linechart"
          :series="regionSeries"
          :config="{
            flipTooltipDate: currentDimension.id === 'fire' ? 100 : 2500,
            dateFormatString: currentDimension.id === 'fire' ? '%e %b %Y' : '%Y'
          }"
        />
      </article>

      <article v-if="tableData" class="col-span-6 w-full mb-8">
        <header class="border-l-4 border-black pl-2 leading-tight">
          <h2 class="text-l md:text-xl">{{ charts.region.title }}</h2>
          <p class="text-sm md:text-base">{{ charts.region.subTitle }}</p>
        </header>

        <table-component
          :table-data="tableData"
          :download-link="dataUrl"
          :options="{
            rank: false,
            sortable: true,
            initialSortKey: Object.keys(this.tableData[0])[1], // first numbers column
            columns: {
              '*': {
                titleFormatter(val) {
                  if (currentDimension.id === 'fire') return printMonth(val.slice(1), '')
                  return val.slice(1)
                },
                formatter(val, i) {
                  return localeFormatter(',d')(val) // no decimals
                }
              },
              country: {
                title: ' ',
                class: 'md:whitespace-no-wrap',
                formatter(v, i) {
                  return iso3ToName(v)
                }
              }
            }
          }"
        />
      </article>
    </div>
  </div>
</template>

<script>
import { iso3ToName } from '@/utils/countryMap'
import { locale } from '@/utils/helpers'
import Map from '@/components/Map'
import MultiLineChart from '@/components/MultiLineChart'
import SparkButton from '@/components/SparkButton'
import Table from '@/components/Table'
import url from '@/utils/url'
// import getCharts from '@/store/charts'

export default {
  name: 'Main',
  components: {
    'map-component': Map,
    'table-component': Table,
    'line-chart': MultiLineChart,
    SparkButton
  },
  data() {
    return {
      dims: ['forestCover', 'forestLoss', 'fire']
    }
  },
  computed: {
    locale() {
      return this.$store.getters.locale
    },
    region() {
      return this.$store.state.region
    },
    country() {
      return this.$store.state.country
    },
    dimension() {
      return this.$store.state.dimension
    },
    regionSlug() {
      return this.$store.state.regionSlug
    },
    kpi() {
      return this.$store.getters.kpi()
    },
    currentDimension() {
      const current = this.$store.getters.pageData()
      return {
        id: this.dimension,
        value: this.kpi.value,
        sub: current.sub,
        desc: current.desc
      }
    },
    // @todo: rename to pageData? Consistent and fixes "dimension.dimension".
    dimensions() {
      return {
        forestCover: this.$store.getters.pageData('forestCover'),
        forestLoss: this.$store.getters.pageData('forestLoss'),
        fire: this.$store.getters.pageData('fire')
      }
    },
    charts() {
      return this.$store.getters.charts()
    },
    countrySeries() {
      return this.$store.getters.series(this.dimension, this.region, this.country)
    },
    regionSeries() {
      return this.$store.getters.seriesTotal(this.dimension, this.region)
    },
    tableData() {
      return this.$store.getters.tableData
    },
    dataUrl() {
      const location = this.dimension === 'fire' ? this.$store.getters.location : this.region
      return url(this.dimension, location, false) // do not add busting
    }
  },
  methods: {
    iso3ToName,
    localeFormatter: locale.format,
    printNumber(num) {
      return num.toLocaleString(this.locale)
    },
    printDate(string, options = {}) {
      const date = date instanceof Date ? date : new Date(string)
      return date.toLocaleDateString(this.locale, options)
    },
    printMonth(string) {
      return this.printDate(string, { month: 'short', year: '2-digit' })
    }
  }
}
</script>
